import { render, staticRenderFns } from "./GroupBtns.vue?vue&type=template&id=42d6a584&"
import script from "./GroupBtns.vue?vue&type=script&lang=js&"
export * from "./GroupBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports